module.exports = __webpack_public_path__ + "static/img/ipl.7f06e64.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/ipl.webp
// module id = AjVE
// module chunks = 0